<template>
  <header>
    <div class="left">
      <div class="img-div">
        <img class="logo" src="https://img.alicdn.com/tps/TB1s0ynNXXXXXcNaFXXXXXXXXXX-48-48.png">
      </div>
      <div class="title-div">
        <span class="title">您的专属小秘</span>
        <span class="info">亲，有关物流快递的相关问题您都可以来咨询我哦！</span>
      </div>
    </div>
    <div class="right">
      <i class="icon time-icon">
        <span class="date">{{ new Date() | date '%Y-%m-%d' }}</span>
        <span class="time">{{ nowTime | date '%T' }}</span>
      </i>
    </div>
  </header>
</template>

<script>
  export default{
    data(){
      return{
        msg:'hello vue',
        nowTime: new Date()
      }
    },
    components:{
    },
    ready() {
      setInterval(() => this.nowTime = new Date(), 1000)
    }
  }
</script>

<style lang="less" scoped>
  @import "../assets/base";

  header {
    height: 70px;
    background-color: @main-color;
    position: relative;
    z-index: 999;

    .left {
      float: left;
      padding: 10px 10px 6px 10px;
      width: 600px;
      line-height: 20px;

      .img-div {
        float: left;
        margin-right: 22px;

        .logo {
          height: 48px;
          width: 48px;
          border: 1px solid rgba(255, 255, 255, 0.6);
          border-radius: 4px;
        }

        .info-icon:after {
          position: absolute;
          width: 20px;
          height: 20px;
          text-align: center;
          content: '\e60e';
          font-size: 16px;
          background-color: #fff;
          border-radius: 10px;
          top: 44px;
          left: 48px;
        }
      }

      .title {
        display: block;
        color: #fff;
        font-size: 16px;
        line-height: 28px;
        font-weight: bold;
      }
      .info {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
      }
    }

    .right {
      float: right;
      font-size: 12px;
      line-height: 16px;
      padding-top: 26px;
      padding-right: 20px;
      color: rgba(255, 255, 255, 0.8);

      .time-icon:before {
        content: '\e60d';
        font-size: 16px;
      }

      span {
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CareHeader.vue?3f92e410